import { track } from '@tldraw/tldraw'
import { BoldProps } from './Types'
import { Bold as Icon } from 'blaze-ui/icons'
import { useUpdateStyle } from '../VisualEditor/hooks/useUpdateStyle'
import { FontWeightStyle } from '../VisualEditor/StyleProps'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { observer } from 'mobx-react-lite'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { useAvailableWeights } from '../VisualEditor/hooks/useAvailableWeights'

const Bold = track(
  observer(({ editor, fontWeightStyle, fontFamilyStyle, italicStyle, tooltipPlacement }: BoldProps) => {
    const updateStyle = useUpdateStyle(editor)
    const availableWeights = useAvailableWeights(fontFamilyStyle, italicStyle)

    const isDisabled = fontWeightStyle.type === 'mixed' || !availableWeights.includes(700)
    const isToggled = fontWeightStyle.type === 'shared' && fontWeightStyle.value === 700

    return (
      <Tooltip label="Bold" placement={tooltipPlacement}>
        <Button
          isDisabled={isDisabled}
          variant={isToggled ? 'squareToggleOn' : 'squareToggleOff'}
          onPress={() => updateStyle(FontWeightStyle, isToggled ? 400 : 700)}
          aria-label="Bold"
          icon={() => <Icon size={20} />}
        />
      </Tooltip>
    )
  }),
)

export { Bold }
